@if (loading) {
  <div class="card text-center">
    <div class="card-body">
      <div class="spinner-border text-blue"></div>
    </div>
  </div>
}

@if(!loading && apps.length > 0) {
  <div class="card text-center">
    <div class="card-header">
      <h3 class="card-title">{{ 'apps.apps' | translate }}</h3>
    </div>

    <div class="card-body d-flex flex-wrap justify-content-center px-1">
      @for (app of apps; track app.identifier) {
        <div class="app-button">
          <a [attr.href]="app.url" class="app-button-link rounded"
            [attr.target]="app.isInternalApp ? null : '_blank'"
            [attr.rel]="app.isInternalApp ? null : 'noopener noreferrer'"
          >
            <div class="p-1">
              <div class="position-relative">
                @if (app.isNew) {
                  <div class="badge bg-primary-lt position-absolute badge-new badge-sm">
                    {{ 'new' | translate | uppercase }}
                  </div>
                }
                
                <img
                  [src]="app.imgSrc" height="50" width="50"
                  class="app-icon"
                  [alt]="'apps.' + app.identifier | translate"
                >
              </div>
              <div class="app-name mt-1 small" [innerHTML]="'apps.' + app.identifier | translate"></div>
            </div>
          </a>

        </div>
      }
      

      @for ( app of appsComingSoon; track app.identifier) {
        <div class="app-coming-soon-button">
          <div>
            <div class="position-relative">
              <img [attr.src]="app.imgSrc" class="app-icon" [alt]="'apps.' + app.identifier | translate"
              >
              <span class="badge badge-pill bg-azure-lt coming-soon-badge">Coming<br/>soon</span>
            </div>
            <p class="mt-1">
              {{ 'apps.' + app.identifier | translate }}
            </p>
          </div>
        </div>
      }
      
    </div>
  </div>
}
